import { Grid, Typography, Divider } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import ExpenseTypeGrid from "./ExpenseTypeGrid";



const ExpenseTypeConfiguration = () => {
  const theme = useTheme();
  const values = [
      { name: "Expense Types", comp: <ExpenseTypeGrid /> },

  ];

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px" }}>
      {values?.map((value, id) => (
        <React.Fragment key={id}>
          <Grid
            item
            xs={12}
            ml={0.5}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                paddingLeft: "15px",
                color: theme.palette.primary.contrastText,
              }}
            >
              {value.name}
            </Typography>
            {value?.comp}
          </Grid>
          {/* {(id % 2 === 1 || id === values.length - 1) && ( */}
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                </Grid>
              {/* )} */}
        </React.Fragment>
      ))}

    </Grid>
  );
};

export default ExpenseTypeConfiguration;
